import { SxProps, Theme } from '@mui/material';

export const storeLocatorSateDropdownSX: SxProps = {
	width: '100%',
	'& .MuiInputBase-input': {
		py: '5px',
		paddingLeft: '10px',
	},
	'& fieldset': {
		borderRadius: '3px',
	},
	'& legend': { display: 'none' },
};

export const storeLocatorSateDropdownElementsSX: Record<string, SxProps<Theme>> = {
	typographyElement: { fontSize: '12px' },
	marginBottom: {
		my: 1,
	},
	myLocationIcon: {
		mr: '5px',
		verticalAlign: 'middle',
		mt: '-4px',
		fontSize: '15px!important',
	},
};
